module.exports = __webpack_public_path__ + "img/任务量@2x.b38087e4.png";